
  <ng-template #resetPassword>
    <div class="modal-header">
      <h4 class="modal-title pull-left f-bold-dubai">Change Password</h4>

      <button type="button" class="close pull-right" aria-label="Close" (click)="modalresetPassword.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <form name="userpasswordForm" (ngSubmit)="userpasswordForm.form.valid && updatePassword()" [mustMatch]="['password', 'confirmPassword']" #userpasswordForm="ngForm" novalidate>
      <div class="modal-body">

        <div class="form-group">
          <label for="exampleInputEmail1">Password<span class="text-danger">*</span></label>
          <input type="password" class="form-control" name="password" [(ngModel)]="model.password" placeholder="Password" #password="ngModel" [ngClass]="{ 'is-invalid': userpasswordForm.submitted && password.invalid }" required minlength="8">
          <div *ngIf="userpasswordForm.submitted && password.invalid" class="invalid-feedback">
            <div *ngIf="password.errors.required">Password is required</div>
            <div *ngIf="password.errors.minlength">Password must be at least 8 characters</div>
          </div>
        </div>
        <div class="form-group">
          <label for="exampleInputEmail1">Confirm Password<span class="text-danger">*</span></label>
          <input type="password" class="form-control" name="confirmPassword" [(ngModel)]="model.confirmPassword" placeholder="Confirm Password" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': userpasswordForm.submitted && confirmPassword.invalid }" required>
          <div *ngIf="userpasswordForm.submitted && confirmPassword.invalid" class="invalid-feedback">
            <div *ngIf="confirmPassword.errors.required">Confirm Password is required</div>
            <div *ngIf="confirmPassword.errors.mustMatch">Passwords must match</div>
          </div>
        </div>

      </div>
      <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-secondary" (click)="modalresetPassword.hide()">Cancel</button>
        <button class="btn btn-success">Submit</button>
      </div>
    </form>
  </ng-template>

<div class=" container-fluid py-3 left-menu-space" id="divMainContainer" role="main">
  <div class="page-title-box d-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-4">User Profile</h4>
    <div class="page-title-right pb-4"><a class="btn btn-secondary btn-sm text-white" routerLink="/dashboard"><i class="fa fa-arrow-left pr-1"></i> Back</a></div>
  </div>

  <div class="row">
    <div class="col-md-6 pageloadcontainer">
      <div class="card rounded p-3 h-100 mb-0">
        <div class="pb-2 border-bottom mb-2">
          <div class="position-absolute rounded-circle position-left-15">
            <img alt="profile" class="wh-70 rounded-circle mr-2" [src]="userInfoList.picture">
            <ng-container>
              <label for="imageUrlMain" style="cursor:pointer; position:absolute; right:15px; top:60px;" title="update Image"
                     data-placement="top">
                <a (click)="openModalImage(userProfilePictueUpdate)"> <i class="fa fa-camera fa-lg "></i></a>
              </label>
            </ng-container>
          </div>
          <div class="ml-6 px-3">
            <h6 class="f-bold-dubai mb-0">{{userInfoList.displayNameEn}}</h6>
            <Small>{{userInfoList.emailId}}</Small><br />
            <Small class="text-secondary">{{userInfoList.designationEn}}</Small><br />
            <Small class="text-secondary">{{userInfoList.divisionNameEn}}</Small>
          </div>
        </div>

        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">Display Name</small></div>
          <div class="px-2"><small>{{userInfoList.displayNameEn}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">PR Number</small></div>
          <div class="px-2"><small>{{userInfoList.prNumber}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">Full Name</small></div>
          <div class="px-2"><small>{{userInfoList.firstname}} {{userInfoList.lastname}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">Role</small></div>
          <div class="px-2"><small>{{userInfoList.role==1?'Admin User':'Basic User'}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">Division</small></div>
          <div class="px-2"><small>{{userInfoList.divisionNameEn}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">Designation</small></div>
          <div class="px-2"><small>{{userInfoList.designationEn}}</small></div>
        </div>
        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">Email Id</small></div>
          <div class="px-2"><small>{{userInfoList.emailId}}</small></div>
        </div>

        <!--<div class="d-flex text-secondary flex-row">
          <div class="p-0"><small class="f-bold-dubai project-label">TBT Available</small></div>
          <div class="px-2"><small>{{userInfoList.isTBT?'Yes':'No'}}</small></div>
        </div>-->
        <div class="d-flex text-secondary flex-row py-1">
          <div class="p-0"><small class="f-bold-dubai project-label">Last Login</small></div>
          <div class="px-2"><small>{{todayTime}}  {{todayDate}}</small></div>
        </div>
        <div class="d-flex flex-row-reverse" *ngIf="isExternal==1">
          <button class="btn btn-success px-4 form-control col-sm-4" (click)="openResetPasswordModal(resetPassword)">Change Password</button>
        </div>
      </div>

    </div>
    <div class="col-md-6 pageloadcontainer">
      <div class="card rounded p-3 h-100 mb-2">

        <form name="userProfileForm" (ngSubmit)="userProfileForm.form.valid && AddEditUserMaster(userInfoList)" #userProfileForm="ngForm" novalidate>
          <div class="row">
            <!-- <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for="displayNameEn">Display Name English</label>
                <input type="text" class="form-control" id="displayNameEn" [ngClass]="{ 'is-invalid': userProfileForm.submitted && displayNameEn.invalid } " name="displayNameEn"
                       [(ngModel)]="model.displayNameEn" #displayNameEn="ngModel" required placeholder="Enter the display name English">
                <div *ngIf="userProfileForm.submitted && displayNameEn.invalid" class="invalid-feedback">
                  <div *ngIf="displayNameEn.errors.required" class="text-danger">Enter the display name English</div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for="displayNameAr">Display Name Arabic</label>
                <input type="text" class="form-control" id="displayNameAr" [ngClass]="{ 'is-invalid': userProfileForm.submitted && displayNameAr.invalid } " name="displayNameAr"
                       [(ngModel)]="model.displayNameAr" #displayNameAr="ngModel" required placeholder="Enter the display name Arabic" />
                <div *ngIf="userProfileForm.submitted && displayNameAr.invalid" class="invalid-feedback">
                  <div *ngIf="displayNameAr.errors.required" class="text-danger">Enter the display name Erabic</div>
                </div>
              </div>
            </div> -->
            <!--<div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for="firstname">First Name</label>
                <input type="text" class="form-control" id="firstname" [ngClass]="{ 'is-invalid': userProfileForm.submitted && firstname.invalid } " name="firstname"
                       [(ngModel)]="model.firstname" #firstname="ngModel" required placeholder="Enter the firstname">
                <div *ngIf="userProfileForm.submitted && firstname.invalid" class="invalid-feedback">
                  <div *ngIf="firstname.errors.required" class="text-danger">Enter the firstname</div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                <label for="lastname">Last Name</label>
                <input type="text" class="form-control" id="lastname" [ngClass]="{ 'is-invalid': userProfileForm.submitted && lastname.invalid } " name="lastname"
                       [(ngModel)]="model.lastname" #lastname="ngModel" required placeholder="Enter the last name">
                <div *ngIf="userProfileForm.submitted && lastname.invalid" class="invalid-feedback">
                  <div *ngIf="lastname.errors.required" class="text-danger">Enter the last name</div>
                </div>
              </div>
            </div>-->
            <div class="col-md-12">
              <div class="clearfix py-2">
                <div class="f-bold-dubai border-bottom py-2">Delegate My Access</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="followUp">Delegate My Access To</label>
                <ng-select [items]="UserList" class="form-control p-0 border-0-container"
                           bindLabel="fullAttendeeName"
                           bindValue="userselUno"
                           [(ngModel)]="model.followUp"
                           id="followUp"
                           name="followUp"
                           [multiple]="false"
                           [searchable]="true"
                           [searchFn]="customSearchFn"
                           [virtualScroll]="true"
                           [minTermLength]="3"
                           placeholder="Delegate Users">

                          <ng-template ng-option-tmp let-item="item">
                          <div class="line">{{item.fullAttendeeName}}</div>
                          <div class="line-email">{{item.emailAtd}}</div>
                        </ng-template>
                </ng-select>

              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <label for="Delegate">&nbsp;</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="true" name="isDelegate" [(ngModel)]="isDelegate" id="defaultCheck1">
                <label class="form-check-label" for="defaultCheck1">
                  Allow confidential meeting access
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="startdate">Start Date</label>
                <input  type="text" onfocus="(this.type='date')" placeholder="MM/DD/YYYY" onkeydown="return false" class="form-control" name="startDate" [(ngModel)]="model.startDate" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="enddate">End Date</label>
                <input  type="text" onfocus="(this.type='date')" placeholder="MM/DD/YYYY" onkeydown="return false" class="form-control" name="endDate" [(ngModel)]="model.endDate" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="followUp">Access</label>
                <ng-select [items]="accessValue" class="form-control p-0 border-0-container"
                           bindLabel="text"
                           bindValue="value"
                           placeholder="Access"
                           name="Access"
                           [(ngModel)]="model.access">
                </ng-select>

              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <label for="CopyEmail">&nbsp;</label>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="true" name="isCopyEmail" [(ngModel)]="isCopyEmail" id="defaultCheck2">
                <label class="form-check-label" for="defaultCheck2">
                  Send me copy of mail
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="Update">&nbsp;</label>
                <button class="btn btn-success px-4 form-control">Update</button>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>

  <div class="row">

    <div class="col-md-12 pageloadcontainer mt-3">
      <div class="card rounded p-3 h-100">
        <h6 class="f-bold-dubai">My Delegated Access</h6>
        <div class="border rounded py-4 text-center text-muted h-100" *ngIf="followUpUserList==null ||followUpUserList.length==0 ">
          <!--<img src="{{noDataImage}}" alt="No Data" />-->
          <h5>No Data Available</h5>
        </div>
        <div class="pt-2 pb-3 border-bottom" *ngFor="let item of followUpUserList">
          <a></a>
          <img [src]="item.picture" alt="profile" class="wh-30 rounded-circle mr-2" />
          <h6 class="card-title d-inline f-bold-dubai pointer" (click)="redirectDelegateMeetingMinutes(item.id,item.isAccess,item.isDelegate)">{{item.displayNameEn}} <span class="float-right"><i class="la la-users fa-2x text-primary"></i></span></h6>
          <div class="text-success pt-1">{{item.designationEn}}  <small class="pr-2 pl-2 text-secondary" *ngIf="item.startDate != '' && item.endDate !=''"> {{item.startDate}} to {{item.endDate}}</small> <small *ngIf="item.isDelegate != 0">| </small> <small class="px-2 text-secondary" *ngIf="item.isDelegate != 0">Confidential</small> <small *ngIf="item.isAccess != 0">|</small> <small class="px-2"><span class="text-secondary" *ngIf="item.isAccess == 1">Read Access</span><span class="text-secondary" *ngIf="item.isAccess == 2">Full Access</span></small></div>  
          <div class="p-0">
            <span class="pr-2"> {{item.prNumber}}</span> |  <span class="px-2">{{item.emailId}}</span> | <span class="px-2"><b class="text-secondary">{{item.divisionNameEn}}</b></span>| <span class="px-2">{{item.ntUsername}}</span>



          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <ng-template #userProfilePictueUpdate>

    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-left px-2">User Profile Picture Update</h4>
        <small class="px-2"><a (click)="modalRef.hide()" class="text-secondary"></a></small>
        <button type="button" class="close close-abs text-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true"><i class="la la-close"></i></span>
        </button>
      </div>
      <div class="modal-body py-3">
        <div class="row">
          <div class="col-md-8">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customFile" accept="image/*"
                     name="imageUrlMain" (change)="fileChangeEvent($event)">
              <label class="custom-file-label" for="customFile">Select Image</label>
            </div>
            <div class="border mh-75 p-2 my-2">
              <div *ngIf="imageChangedEvent && imageChangedEvent!=''; else imgelse">
                <div class="col-lg-12 p-0 justify-content-center dp-col text-center">
                  <image-cropper [imageChangedEvent]="imageChangedEvent"
                                 [maintainAspectRatio]="true"
                                 [aspectRatio]="4 / 3"
                                 format="png"
                                 [style.display]="showCropper ? null : 'none'"
                                 (imageLoaded)="imageLoaded()"
                                 (imageCropped)="imageCropped($event)">

                  </image-cropper>
                </div>
              </div>
              <ng-template #imgelse>
                <!--<img src="{{noDataImage}}" alt="No Data" />-->
                <h5>No Data Available</h5>
              </ng-template>
            </div>
          </div>
          <div class="col-md-4 position-relative">
            <div class="h-100">
              <div class="border px-3 mb-3">
                <div class="row">
                  <div class="bg-light text-center col-md-12 p-0">Old Photo</div>
                  <div class="col-5">
                    <img [src]="profilePicture" class="img-fluid py-3" />
                  </div>
                  <div class="col-7" *ngIf="profilePicture!='' && profilePicture!='assets/img/user-default.png'">
                    <button type="button" class="btn btn-info btn-sm d-block text-left my-4 float-right" (click)="DeleteConfirm(userInfoList)"><i class="fa fa-close"></i> Remove</button>
                  </div>
                </div>
              </div>
              <div class="mb-2 text-center min-hgt-210">
                <div class="border mb-2" *ngIf="croppedImage !=''">
                  <div class="bg-light text-center mb-3">Preview</div>
                  <img alt="profile" class="wh-100 mr-2 mb-3" [src]="croppedImage">
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer bg-light py-1">
        <ng-container>
          <div class="py-0">
            <a class="btn btn-sm btn-dark mx-2 text-white" (click)="clearImage()"><i class="fa fa-close"></i> Clear</a>
            <a (click)="saveImage()" class="btn btn-primary btn-sm mx-2 text-white"><i class="fa fa-save"></i> Save</a>
          </div>
        </ng-container>
      </div>
    </div>

  </ng-template>
